var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEndTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-B-testing",
    transform: "translate(-771.000000, -1356.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-end-test",
    transform: "translate(771.000000, 1356.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.3,
    x: 0.7,
    y: 2.8,
    width: 11.2,
    height: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,1.4 L8.26,1.4 C7.98,0.56 7.21,0 6.3,0 C5.39,0 4.62,0.56 4.34,1.4 L1.4,1.4 C0.63,1.4 0,2.03 0,2.8 L0,12.6 C0,13.37 0.63,14 1.4,14 L11.2,14 C11.97,14 12.6,13.37 12.6,12.6 L12.6,2.8 C12.6,2.03 11.97,1.4 11.2,1.4 Z M11.2,12.6 L1.4,12.6 L1.4,2.8 L6.3,2.8 C5.88,2.8 5.6,2.52 5.6,2.1 C5.6,1.68 5.88,1.4 6.3,1.4 C6.72,1.4 7,1.68 7,2.1 C7,2.52 6.72,2.8 6.3,2.8 L11.2,2.8 L11.2,12.6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.6 10.08 3.01 7.49 3.99 6.51 5.6 8.12 8.61 5.11 9.59 6.09"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndTest);
export default __webpack_public_path__ + "static/media/icon-end-test.864c9c116e4de6524345a1b6652b6fd5.svg";
export { ForwardRef as ReactComponent };